import { render, staticRenderFns } from "./list_attribute.vue?vue&type=template&id=05d4faba&scoped=true"
import script from "./list_attribute.vue?vue&type=script&lang=js"
export * from "./list_attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d4faba",
  null
  
)

export default component.exports